export const TESTIDS = {
  nav: {
    logo: "nav-logo",
    linkProducts: "nav-link-products",
    linkAbout: "nav-link-about",
    linkFaq: "nav-link-faq",
    cta: "nav-cta-button",
  },
  hero: {
    section: "hero-section",
    cta: "hero-cta-button",
    secondaryCta: "hero-secondary-cta",
    mockup: "hero-mockup-image",
  },
  products: {
    section: "products-section",
    card: (i) => `product-card-${i}`,
    buy: (i) => `product-buy-${i}`,
    details: (i) => `product-details-${i}`,
    dialog: (i) => `product-dialog-${i}`,
    dialogBuy: (i) => `product-dialog-buy-${i}`,
  },
  manifesto: { section: "manifesto-section" },
  about: { section: "about-section" },
  testimonials: { section: "testimonials-section" },
  faq: { section: "faq-section", item: (i) => `faq-item-${i}` },
  lead: {
    section: "lead-section",
    form: "lead-form",
    name: "lead-input-name",
    email: "lead-input-email",
    message: "lead-input-message",
    submit: "lead-submit-button",
  },
  footer: { section: "footer-section", shopCta: "footer-shop-cta" },
};
